import { GlobalToastType, kToastDurationShortMs } from '@/constants/constants-ui'
import { openGlobalToast } from '@/store/slices/global-toast.slice'
import { store } from '@/store/store'
import { saveHTMLasDocx } from '../fetch/post-download-html-docx'

export function formatHtmlForDocXTransformation(sourceHTML: string) {
  const highlightRegex = /<span class="highlighted-snippet bg-yellow-200">(.*?)<\/span>/g
  const h1ToBRegex = /<h\d>(.*?)<\/h\d>/g

  let outputHtml = sourceHTML
  try {
    outputHtml = outputHtml.replace(highlightRegex, '<mark>$1</mark>')
    outputHtml = outputHtml.replace(h1ToBRegex, '<b>$1</b>')
  } catch (error) {
    console.error('Error processing html string:', error)
  }
  return outputHtml
}

export async function downloadReferenceAsDocX(sourceHTML: string | Promise<string>, fileName: string, onLoading: (loading: boolean) => void) {
  onLoading(true)
  try {
    const outputHtml = formatHtmlForDocXTransformation(await sourceHTML)
    await saveHTMLasDocx({ html: outputHtml, fileName })
    store.dispatch(openGlobalToast({ type: GlobalToastType.SUCCESS, message: `${fileName} downloaded`, durationMs: kToastDurationShortMs }))
  } catch (error) {
    store.dispatch(openGlobalToast({ type: GlobalToastType.ERROR, message: 'Reference download failed', durationMs: kToastDurationShortMs }))
    throw error
  } finally {
    onLoading(false)
  }
}
